import { makeStyles } from "@mui/styles";
import { primary_gradient_reverse } from "../../themes/colors";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 10,
    color: "#fff",
    overflow: "auto",
    paddingBottom: "100px",
    overflowY: "scroll",
  },
  card: { width: "600px", marginTop: "100px", marginLeft: 10, marginRight: 2 },
  card_expaned: { width: "1100px", marginTop: "100px" },
  card_header: {
    backgroundImage: primary_gradient_reverse,
    color: "white",
    fontWeight: "bold",
    fontSize: "15px",
    padding: "10px",
  },
  text_field: { width: "100%" },
  button_row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
  },
  button_row_center: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "center",
  },
  add_payment_card: {
    width: "400px",
  },
  color_row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
});

export default useStyles;
